import { Search } from 'lucide-react';

export default function SearchBox() {
  return (
    <div className="relative max-w-[440px] flex-1">
      <Search
        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-t3"
        size={14}
      />
      <input
        type="search"
        placeholder="Search aliases, senders, activity…"
        className="w-full rounded-[9px] border border-line bg-surface-2 py-2 pl-9 pr-12 text-[13.5px] text-t1 outline-none transition-colors placeholder:text-t3 focus:border-gold focus:shadow-[0_0_0_3px_var(--gold-dim)]"
      />
      <kbd className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 rounded border border-line bg-surface-3 px-1.5 py-[1px] font-mono text-[10px] font-semibold text-t3">
        ⌘K
      </kbd>
    </div>
  );
}
